'use client';

import { useUserWallets } from '@dynamic-labs/sdk-react-core';

import { GET_ASSETS_FOR_USER } from '@repo/api-core-toolkit';
import { tw } from '@repo/ui';
import {
  roundToTwoSignificantDigitsWithMinDecimals,
  useDatabaseQuery,
} from '@repo/utils';

import { Table } from './table';
import { TotalDood } from './total-dood';

interface AssetsProps {
  isClaimActive: boolean;
  hasDood: boolean;
}

export const Assets: React.FC<AssetsProps> = ({ isClaimActive, hasDood }) => {
  const userWallets = useUserWallets();

  const {
    data: assetsForUser,
    isLoading,
    isFetching,
  } = useDatabaseQuery({
    queryKey: ['assets for user', userWallets.map((wallet) => wallet.address)],
    query: GET_ASSETS_FOR_USER as any,
    variables: { data: { userAddress: null } },
    field: 'getAssetsForUser',
    enabled: true,
    headers: {
      'api-key': process.env.NEXT_PUBLIC_GRAPHQL_API_KEY as string,
    },
  });

  const isDataLoading = isLoading || isFetching;

  const formattedTotal = roundToTwoSignificantDigitsWithMinDecimals(
    assetsForUser?.totalAvailableToClaim ?? 0,
  ).toLocaleString();

  return (
    <div
      className={tw(
        'relative flex flex-col gap-7',
        hasDood ? 'pt-40 md:pt-60' : null,
      )}
    >
      <TotalDood
        hasDood={hasDood}
        formattedTotal={formattedTotal}
        isLoading={isDataLoading}
      />

      <Table
        data={assetsForUser?.availableToClaimPerAssetType ?? []}
        isLoading={isDataLoading}
        isClaimActive={isClaimActive}
      />

      {hasDood || isDataLoading ? null : (
        <div className='flex w-full flex-col items-center justify-center'>
          <p className='z-10 my-3 text-center text-lg text-white/50 md:text-xl'>
            None of your connected wallets are eligible to receive $DOOD
          </p>
          <p
            className={tw(
              '-mb-2 mt-2 text-2xl font-semibold text-[#05FFA9] md:-mb-6 md:text-3xl',
            )}
          >
            $DOOD WAITING
          </p>
          <p className='text-[54px] font-bold text-white md:text-[88px]'>0</p>
        </div>
      )}
    </div>
  );
};
